import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
export default {
  name: "app-detail-sync",
  props: {
    form: {
      type: Object,
      default() {
        return {};
      }
    },
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    _columns() {
      return this.columns.filter(v => {
        if (this.form.accountCreationRule === "NEVER") {
          return v.key === "accountCreationRule";
        } else {
          return true;
        }
      });
    },
    // opera
    _isOperaCloud() {
      return this.detail.appId === "ID_OPERA_CLOUD";
    }
  },
  data() {
    const h = this.$createElement;
    return {
      autofillKey: `${Date.now()}`,
      columns: [{
        title: $t("arefbk4", "创建账号"),
        key: "accountCreationRule",
        renderForm: () => {
          return h("div", [h("i-Switch", {
            "attrs": {
              "true-value": "AUTO_NAME",
              "false-value": "NEVER"
            },
            "style": {
              width: "43px"
            },
            "model": {
              value: this.form.accountCreationRule,
              callback: $$v => {
                this.$set(this.form, "accountCreationRule", $$v);
              }
            }
          })]);
        }
      }, {
        title: $t("ogwh2", "账号"),
        key: "accountCodePrefix",
        renderForm: () => {
          if (this._isOperaCloud) {
            return h("span", [$t("s5n5td9", "手机号作为登录账号")]);
          } else {
            return h("div", [h("Input", {
              "attrs": {
                "value": this.form.accountCodePrefix,
                "disabled": this.form.accountCreationRule === "NEVER",
                "name": `account_code_prefix_${this.autofillKey}`,
                "placeholder": $t("v1619h5", "代码自定义"),
                "autocomplete": "new-password"
              },
              "on": {
                "input": val => {
                  // 过滤前后空格
                  if (val.trim() !== val) {
                    val = val.trim();
                  }
                  this.form.accountCodePrefix = val.toUpperCase();
                }
              },
              "style": {
                width: "200px"
              }
            }), h("span", [$t("imybdgn", "+部门代码（自动生成）+姓名首字母（自动生成）")])]);
          }
        }
      }, {
        title: $t("g9ob2", "密码"),
        key: "passwordCreationRule",
        renderForm: () => {
          return h("RadioGroup", {
            "model": {
              value: this.form.passwordCreationRule,
              callback: $$v => {
                this.$set(this.form, "passwordCreationRule", $$v);
              }
            }
          }, [h("Radio", {
            "attrs": {
              "label": "DOWNSTREAM_DEFAULT",
              "disabled": this.form.accountCreationRule === "NEVER"
            }
          }, [$t("pjigrg8", "使用应用默认密码")]), h("Radio", {
            "attrs": {
              "label": "CUSTOM",
              "disabled": this.form.accountCreationRule === "NEVER"
            }
          }, [h("span", [$t("mmnl045", "自定义密码")]), h("Input", {
            "attrs": {
              "placeholder": $t("igaffx4", "输入密码"),
              "type": "password",
              "password": true,
              "name": `custom_default_password_${this.autofillKey}`,
              "disabled": this.form.accountCreationRule === "NEVER",
              "autocomplete": "new-password"
            },
            "style": {
              width: "200px"
            },
            "model": {
              value: this.form.defaultPassword,
              callback: $$v => {
                this.$set(this.form, "defaultPassword", $$v);
              }
            }
          })]), h("Radio", {
            "attrs": {
              "label": "RANDOM",
              "disabled": this.form.accountCreationRule === "NEVER"
            }
          }, [$t("jwiki38", "使用随机密码机制")])]);
        }
      }]
    };
  }
};